module.exports = __webpack_public_path__ + "media/images/vector-24@2x-2588939e58899d4b372554465ad80bf9.png";